import { FormattedMessage } from 'react-intl';

const CheckboxBtn = ({ name, selected, disabled, onChange }) => {
    return (
        <>
            <div className={`align-items-center mt-2${disabled ? ' hidden' : ''}`}>
                <div className="form-check form-check-inline" /*style={{paddingLeft: '0px'}}*/>
                    <input
                        className="form-check-input"
                        style={{/*float: 'right', */width: '18px', height: '18px'}}
                        type="checkbox"
                        name={name}
                        disabled={disabled}
                        id={`${name}`}
                        checked={selected}
                        onChange={onChange}
                    />
                    <label className="form-check-label mes-from-label-1 me-4" htmlFor={`${name}`}><FormattedMessage id={name} /></label> 
                </div>
            </div>
        </>
    );
}

export default CheckboxBtn;